module.exports = __webpack_public_path__ + "img/n.495c6772.svg";